var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "w-60 h-full",
      attrs: { "data-grm-comp": "RoomCBTViewInfo" },
    },
    [
      _c("div", { staticClass: "room-cbt-view-info" }, [
        _c(
          "div",
          { staticClass: "bg-indigo-50 flex justify-center items-center" },
          [_c("RoomCBTTimer", { staticClass: "w-full" })],
          1
        ),
        _c("div", { staticClass: "room-cbt-view-info-body" }, [
          _c(
            "div",
            { staticClass: "room-cbt-view-info-contents" },
            [
              _c(
                "div",
                { staticClass: "room-cbt-view-info-contents-header" },
                [
                  _c(
                    "GrmCheckbox",
                    {
                      attrs: { id: "showAnswer" },
                      model: {
                        value: _vm._showAnswer,
                        callback: function ($$v) {
                          _vm._showAnswer = $$v
                        },
                        expression: "_showAnswer",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("testBank.info.showAnswer")))]
                  ),
                ],
                1
              ),
              _c("perfect-scrollbar", { staticClass: "min-h-0 flex-1" }, [
                _c(
                  "div",
                  { staticClass: "room-cbt-view-info-contents-body" },
                  [
                    _c(
                      "RoomCBTInfoForm",
                      { attrs: { users: _vm.getRoomProgressCBTUserList } },
                      [_vm._v(_vm._s(_vm.$t("testBank.info.ongoing")))]
                    ),
                    _c(
                      "RoomCBTInfoForm",
                      { attrs: { users: _vm.getRoomCompleteCBTUserList } },
                      [_vm._v(_vm._s(_vm.$t("testBank.info.submitComplete")))]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "room-cbt-view-info-footer" }, [
          _c("div", { staticClass: "room-cbt-view-button-wrapper" }, [
            _c(
              "button",
              {
                staticClass: "room-cbt-view-button finish",
                on: { click: _vm.onClickFinish },
              },
              [_vm._v(_vm._s(_vm.$t("common.quit")))]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }